module.exports = "<div class=\"modal-dialog\">\n  <div class=\"modal-content\">\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\">{{title || 'Alert!'}}</h4>\n      <button type=\"button\" class=\"close\" (click)=\"close()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n      <p>{{message || 'Warning!'}}</p>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" class=\"btn btn-primary\" (click)=\"close()\">OK</button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-alert/modal-alert.component.html
// module id = ./src/app/shared/modal/modal-alert/modal-alert.component.html
// module chunks = main